import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-about-the-titan-app',
  templateUrl: './about-the-titan-app.component.html',
  styleUrls: ['./about-the-titan-app.component.scss']
})
export class AboutTheTitanAppComponent {
  urlBlobStorage: string= environment.blobstorage;
  downloadToApp(): void {
    window.location.href = 'https://gtstgeneralprod.blob.core.windows.net/app/TitanApp.apk';
  }
}
